import { FlexyIconButton, useModal } from '@europrocurement/flexy-components';
import React from 'react';
import { useSnackbar } from 'notistack';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { FaOptionIcon, noteIcon } from '@europrocurement/l2d-icons';
import {
    Layout,
    LAYOUT_DOCUMENTS_FULL,
    LAYOUT_FORMS_FULL,
} from '@europrocurement/l2d-modules/modules/Dossiers/constants';

import { SelectedDossierProvider } from '@europrocurement/l2d-modules/modules/Dossiers/providers';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import { ModalListNotes } from '@europrocurement/l2d-modules/modules/Notes';

export type DossierValidationCustomHeaderActionsProps = {
    currentLayout: Layout;
    onLayoutChange: (layout: Layout) => void;
    dossier?: DossierOpenSearch;
    saveBeforeOpenFullForm: () => void;
};
const DossierValidationCustomHeaderActions: React.FunctionComponent<DossierValidationCustomHeaderActionsProps> =
    function ({ currentLayout, onLayoutChange, saveBeforeOpenFullForm, dossier }) {
        const { modalActions } = useModal();
        const { palette } = useTheme();
        const { enqueueSnackbar } = useSnackbar();

        const handleDisplayListNotes = () => {
            if (!dossier || !dossier.id) {
                enqueueSnackbar(
                    "Une erreur est survenue lors de l'ouverture des notes, dossier non trouvé",
                    { variant: 'error' },
                );
                return;
            }
            modalActions.call(
                <SelectedDossierProvider>
                    <ModalListNotes dossierProps={dossier} />
                </SelectedDossierProvider>,
            );
        };

        return (
            <Box sx={{ display: 'flex', gap: '8px' }}>
                <Button
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0 4px',
                        color: palette.primary.dark,
                        ':hover': {
                            color: palette.primary.main,
                        },
                    }}
                    onClick={() => handleDisplayListNotes()}
                >
                    <FlexyIconButton
                        displayTooltip
                        icon={noteIcon}
                        onClick={() => {}}
                        tooltipOverwriteProps={{
                            title: 'Ajouter une note',
                        }}
                        iconOverwriteProps={{
                            color: palette.primary.dark,
                        }}
                    />
                    Mémos
                </Button>
                {currentLayout !== LAYOUT_DOCUMENTS_FULL && (
                    <Button
                        onClick={() => onLayoutChange(LAYOUT_DOCUMENTS_FULL)}
                        sx={{
                            color: palette.primary.dark,
                            ':hover': {
                                color: palette.primary.main,
                            },
                            transition: 'color 0.25s ease',
                        }}
                    >
                        <FaOptionIcon
                            sx={{
                                lineHeight: 0,
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '14px',
                            }}
                            icon={['fasl', 'arrow-up-right-from-square']}
                        />
                        <Typography variant="l2dcaption">Documents</Typography>
                    </Button>
                )}
                {currentLayout !== LAYOUT_FORMS_FULL && (
                    <Button
                        onClick={saveBeforeOpenFullForm}
                        sx={{
                            color: palette.primary.dark,
                            ':hover': {
                                color: palette.primary.main,
                            },
                        }}
                    >
                        <FaOptionIcon
                            sx={{
                                lineHeight: 0,
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '14px',
                            }}
                            icon={['fasl', 'arrow-up-right-from-square']}
                        />
                        <Typography variant="l2dcaption">Formulaires</Typography>
                    </Button>
                )}
            </Box>
        );
    };

export default DossierValidationCustomHeaderActions;
